// extracted by mini-css-extract-plugin
export default {"add":"control_add__Dfofm","tooltip":"control_tooltip__8-FLj"};